// import packages
import React, { useContext } from "react";
import { LegacyCard as Card, TextField, Layout, FormLayout, BlockStack } from "@shopify/polaris";

// import context
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import contexts
import { PrivateContext } from "lib/context/privateContext";
import { FormContext } from "../../../context/context";

const {
  PRICE = "",
  COMPARE_PRICE = "",
  value: { MIN_PRICE = 0, MAX_FLAT = 9999 },
  symbol: { DOLLAR },
} = constant;

const Price = () => {
  const { data, handleChange, learnMore } = useContext(FormContext);
  const {
    cms,
    currentUser: { moneyFormat = DOLLAR },
  } = useContext(PrivateContext);

  const acceptOnlyValidInput = (value, prevValue) => {
    return (baseHelper.validatePositiveNumericValues(value) && value) || (value !== "" && prevValue);
  };
  return (
    // <Layout.AnnotatedSection
    //   title={cms("section.form.section.price.title")}
    //   description={cms("section.form.section.price.description")}
    // >
    <Card
      title={cms("section.form.section.price.title")}
      id="productPrice"
      actions={[
        {
          content: cms("common.label.learnMore"),
          onAction: () => {
            learnMore("productPrice", cms("section.form.section.price.title"));
          },
        },
      ]}
    >
      <Card.Section>
        <BlockStack gap="2">{cms("section.form.section.price.description")}</BlockStack>
        <br />
        <FormLayout>
          <FormLayout.Group condensed>
            <TextField
              id="price"
              label={cms("section.form.section.price.label.price")}
              min={MIN_PRICE}
              max={MAX_FLAT}
              value={data.price || ""}
              placeholder="0.00"
              prefix={`${moneyFormat}`}
              onChange={(value) => handleChange(PRICE, acceptOnlyValidInput(value, data.price))}
            />
            <TextField
              id="comparePrice"
              label={cms("section.form.section.price.label.comparePrice")}
              min={MIN_PRICE}
              max={MAX_FLAT}
              placeholder="0.00"
              prefix={`${moneyFormat}`}
              value={data.comparePrice || ""}
              onChange={(value) => {
                handleChange(COMPARE_PRICE, acceptOnlyValidInput(value, data.comparePrice));
              }}
            />
          </FormLayout.Group>
        </FormLayout>
      </Card.Section>
    </Card>
    // </Layout.AnnotatedSection>
  );
};

export default Price;
